export enum WarehouseTab {
  Stock = 'stock',
  Shipments = 'shipments',
  Receipts = 'receipts',
  Orders = 'orders',
  InTransit = 'in_transit',
  Movements = 'movements',
  Settings = 'settings',
}

export const isWarehouseTab = (tab: string): tab is WarehouseTab => {
  return Object.values(WarehouseTab).includes(tab as WarehouseTab)
}

export type WarehouseTabInfo = {
  key: WarehouseTab
  title: string
  isStub: boolean
  isActive: boolean
}

export type WarehouseTabs = Map<WarehouseTab, WarehouseTabInfo>
